//src/app/features/questionnaires/components/WizardFooter/components/DesktopSkeleton.tsx
import { ComponentType } from 'react';

interface DesktopSkeletonProps {
  ProceedBtn: ComponentType;
  CancelBtn: ComponentType;
  PreviousBtn: ComponentType;
}

const DesktopSkeleton = ({
  ProceedBtn,
  CancelBtn,
  PreviousBtn,
}: DesktopSkeletonProps) => {
  return (
    <div className="flex mt-auto p-4">
      <div>{<PreviousBtn />}</div>
      <div className="flex ml-auto">
        <div className="mr-4">{<CancelBtn />}</div>
        <div>{<ProceedBtn />}</div>
      </div>
    </div>
  );
};

export default DesktopSkeleton;
